<template>
  <div class="home_module">
    <div class="home_banner">
      <enhome-banner></enhome-banner>
    </div>
    <div class="home_pt">
      <enping-tai></enping-tai>
    </div>
    <div class="home_summary">
      <enhome-summary></enhome-summary>
    </div>
    <div class="home_hoder">
      <enshare-hoder></enshare-hoder>
    </div>
    <div class="home_product">
      <enhome-product></enhome-product>
    </div>
    <div>
      <enhome-news></enhome-news>
    </div>
  </div>
</template>
<script>
import enhomeBanner from './banner';
import enpingTai from './pingtai';
import enhomeSummary from './homeSummary';
import enshareHoder from './shareHoder';
import enhomeProduct from './homeProduct';
import enhomeNews from './homeNews';

export default {
  data() {
    return {};
  },
  components: {
    enhomeBanner,
    enpingTai,
    enhomeSummary,
    enshareHoder,
    enhomeNews,
    enhomeProduct
  },
  methods: {}
};
</script>
<style scoped>
.home_module {
  background-color: #f3f3f3;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}
.home_banner {
  min-height: 500px;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 6;
}
.home_pt {
  width: 100%;
  height: 260px;
  padding: auto 0;
}
.home_summary {
  min-height: 400px;
  width: 100%;
}
.home_hoder {
  min-height: 300px;
  width: 100%;
  text-align: center;
}
.home_product {
  padding: 10px 0;
  background-color: #e9f5f7;
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/home/home.vue